<template lang="pug">
.page
  .container
    .header
      h1.h1 Debug fetch
      .url
        BriqInput(label="url" v-model="innerUrl")
      .request-header
        BriqInput(label="header-key" v-model="headerKey")
        BriqInput(label="header-value" v-model="headerValue")
      .send-button
        BriqCheckbox(label="use token" v-model="useToken")
        BriqButton(@click="send" :disabled="pending") send
    .content
      template(v-if="pending") Awaiting response...
      template(v-else)
        template(v-if="error")
          h2 An error occured
          p {{ error }}
        template(v-else)
          h2 Response:
          .response
            pre {{ formattedResponse }}
</template>

<script>
import { mapGetters } from 'vuex'
import createDebugRequest from './createDebugRequest.js'

export default {
  name: 'DebugFetch',
  data() {
    return {
      innerUrl: null,
      headerKey: null,
      headerValue: null,
      pending: false,
      response: null,
      error: null,
      useToken: true,
    }
  },
  computed: {
    ...mapGetters('user', ['token']),
    formattedResponse() {
      return this.response ? JSON.stringify(this.response.data, null, 4) : null
    },
  },
  methods: {
    async send() {
      if (!this.innerUrl) {
        alert('Please enter a relative path in the url field')
        return
      }
      this.error = null
      this.pending = true
      try {
        const headers =
          this.headerKey && this.headerValue ? { [this.headerKey]: this.headerValue } : null
        const token = this.useToken ? this.token : null
        const task = createDebugRequest(this.$apiClient)({ url: this.innerUrl, headers, token })
        this.response = await task()
      } catch (e) {
        this.error = e
      }
      this.pending = false
    },
  },
}
</script>

<style scoped lang="stylus">
.url, .request-header
  margin-bottom 20px

.request-header
  display flex

.page
  width 100%
  display flex
  justify-content center

.container
  margin-top 30px
  max-width 1200px
  min-width 800px
  padding 30px

.header
  margin-bottom 30px

.response
  border 1px solid #ccc
  border-radius 3px
  background-color #f8f8f8
  padding 8px
  text-align left

  pre
    overflow hidden
</style>
